import { render, staticRenderFns } from "./invoiceDetails.vue?vue&type=template&id=b434d246&scoped=true&"
import script from "./invoiceDetails.vue?vue&type=script&lang=js&"
export * from "./invoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetails.vue?vue&type=style&index=0&id=b434d246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b434d246",
  null
  
)

export default component.exports